<section>

    <img src="assets/images/bannerFelpudo.jpg" alt="Banner SSR" class="img-fluid w-100">

    <div class="container py-4">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="row  align-items-end">
                    <div class="col-12 text-center pb-5">
                        <h2 class="text-dark  p-3 d-inline-block">
                            <a href="/" class="text-decoration-none text-primary">Inicio</a> - FELPUDO
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row g-4 mb-5" id="motivacion">
        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Motivación</h3>
                <hr>
                <p>La educación actual contempla la inclusión de Tecnologías de Información y Comunicación (TICs), sin
                    embargo existen vacíos con cuanto a la implementación de herramientas que sirvan de apoyo para la
                    estimulación temprana, en la etapa de educación inicial.</p>
            </div>
        </div>

        <div class="egames-video-area col-md-6 animate-box fadeInUp animated-fast">
            <div class="ratio ratio-16x9">
                <video controls poster="assets/images/Logo-FELPUDO.jpeg" width="60%">
                    <source src="videos/felpudo/felpudo.mp4" type="video/mp4">
                </video>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row py-lg-5" id="problematica">
        <div class="col-12 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Problemática</h3>
                <hr>
                <p>Es de vital importancia tener en cuenta que a nivel mundial el 39% de niños menores de cinco años
                    viven
                    en la pobreza y no tienen acceso a la educación inicial, así como el interés que se debe dar a los
                    primeros cinco años de vida del niño como "los más importantes para el desarrollo del cerebro,
                    incluyendo la adquisición de habilidades cognitivas, sociales y emocionales" (World Bank Group,
                    2015).
                </p>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row py-lg-5" id="propuesta">
        <div class="col-12 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Propuesta</h3>
                <hr class="my-3">
                <p class="mb-0">El presente proyecto tiene por objetivo principal el de servir como herramienta de
                    soporte
                    pedagógico en la etapa de educación inicial, especialmente dirigido a niñas y niños de uno a cinco
                    años
                    de edad. Las tres capas identifican los elementos que se interrelacionan con las áreas de
                    conocimiento.
                </p>
            </div>
        </div>
    </div>
</section>


<section class="container py-2">
    <!-- Imagen Fig.1 -->
    <div class="row mb-5">
        <div class="col-12 text-center">

            <img src="assets/images/Picture7.png" alt="Simply Easy Learning" class="img-fluid"
                style="max-width: 800px;">
            <p class="mt-3"><strong>Fig.1</strong> Arquitectura general del sistema</p>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row py-lg-5">
        <div class="col-12 animate-box fadeInUp animated-fast">
            <div class="accordion" id="accordionExample">
                <!-- Item 1 -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                            Capa de interfaz de usuario:
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <p>En esta capa se destaca la aplicación móvil, la cual sirve como medio para que los
                                profesores
                                seleccionen el área de conocimiento y los niños puedan interactuar con el asistente
                                robótico
                                en las actividades de aprendizaje y los juegos correspondientes a cada área; esto genera
                                en
                                los niños estímulos auditivos, visuales y táctiles.</p>
                        </div>
                    </div>
                </div>

                <!-- Item 2 -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            Capa de servicios:
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <p>Esta capa desempeña la función de interfaz o medio para realizar el registro de la
                                información y acceso a la base de datos.</p>
                        </div>
                    </div>
                </div>

                <!-- Item 3 -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                            Capa de conocimiento:
                        </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <p>En esta capa cada área tiene como objetivo desarrollar en el niño un aprendizaje
                                particular,
                                como conocimiento base y/o aprendizaje en su etapa de desarrollo inicial.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <div class="row py-lg-5 pt-5" id="resultados">
        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="text-center pt-5">
                <img class="img-fluid mx-auto d-block" src="assets/images/Picture8.png"
                    alt="Resultados de encuesta sobre FELPUDO">
                <div class="mt-3">
                    <p class="mb-0"><strong>Fig.2</strong> Resultados obtenidos de la encuesta sobre la aceptación del
                        asistente robótico FELPUDO. (Robles et al., 2019).</p>
                </div>
            </div>
        </div>

        <div class="col-md-6 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <h3>Resultados</h3>
                <hr class="my-3">
                <p>Según la encuesta realizada a 18 niños y 29 niñas entre cuatro y cinco años de edad de la Unidad
                    Educativa "Santa Mariana de Jesús" de la ciudad de Cuenca, Azuay - Ecuador, se utilizó el
                    coeficiente
                    Alfa de Cronbach (Hernández Sampieri et al., 2014) para medir la confiabilidad y aceptación del
                    proyecto, obteniendo un valor alfa de 0.70 que representa un porcentaje aceptable. La siguiente
                    imagen
                    detalla que:</p>
            </div>

            <ul class="list-unstyled mt-4">
                <li class="mb-2">"El robot se considera una herramienta excelente para apoyar el proceso de aprendizaje
                    (como herramienta de apoyo en las clases).</li>
                <li class="mb-2">La voz del robot se percibe como buena y excelente para niños con edades de cuatro y
                    cinco
                    años, respectivamente.</li>
                <li class="mb-2">Los niños consideran el robot y la aplicación móvil como herramientas buenas/excelentes
                    no
                    sólo para aprender sino también para jugar.</li>
                <li class="mb-2">La percepción general de todo el sistema alcanzó las puntuaciones altas y muy altas
                    según
                    los criterios de los niños con edades de cuatro y cinco años, respectivamente." (Robles et al.,
                    2019)
                </li>
            </ul>

            <p class="mt-3">A nivel de la provincia del Azuay podrían beneficiarse del proyecto un total de 19519 niñas
                y
                19008 niños entre uno a cinco años de edad. Si se toma en cuenta las provincias restantes, se tendría un
                total de 342226 niñas y 341577 niños.</p>
        </div>
    </div>
</section>

<section class="container py-2">

    <div class="row mb-5">
        <div class="col-12 text-center">
            <img src="assets/images/beneficiariosFelpudo.png" alt="Simply Easy Learning"
                class="img-fluid" style="max-width: 800px;">
            <p class="mt-3"><strong>Fig.3</strong>Beneficarios Indirectos FELPUDO</p>
        </div>
    </div>
</section>

<section class="container py-2">


    <div class="row g-4 py-lg-5">
        <div class="col-md-12 animate-box fadeInUp animated-fast">
            <div class="about-desc">
                <div id="colorlib-project">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-8 text-center animate-box fadeInUp animated-fast">
                                <h3 class="mb-3">Interacción con el asistente robótico</h3>
                                <p class="mb-5">Pruebas realizadas en la Unidad Educativa "Santa Mariana de Jesús" con
                                    niños
                                    y niñas de cuatro a cinco años de edad en el área de reconocimiento de las partes
                                    del
                                    cuerpo.</p>
                            </div>
                        </div>

                        <!-- Image Gallery -->
                        <div class="row g-4">
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofelpudo/1.png"
                                    alt="Interacción con FELPUDO 1" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofelpudo/1.png">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofelpudo/2.png"
                                    alt="Interacción con FELPUDO 2" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofelpudo/2.png">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofelpudo/5.png"
                                    alt="Interacción con FELPUDO 5" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofelpudo/5.png">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofelpudo/6.png"
                                    alt="Interacción con FELPUDO 6" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofelpudo/6.png">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofelpudo/7.png"
                                    alt="Interacción con FELPUDO 7" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofelpudo/7.png">
                            </div>
                            <div class="col-md-4 col-6 animate-box fadeInUp animated-fast">
                                <img class="img-fluid rounded shadow-sm" src="assets/images/fotofelpudo/8.png"
                                    alt="Interacción con FELPUDO 8" data-bs-toggle="modal" data-bs-target="#imageModal"
                                    data-bs-img="assets/images/fotofelpudo/8.png">
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="my-5">

               <!--  <h4 class="mb-4">Para desarrolladores:</h4> -->
                <!-- Optional link can be added here -->
            </div>
        </div>
    </div>
</section>
<section class="container py-2">

    <!-- Single Modal for all images -->
    <div class="modal fade" id="imageModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center">
                    <img id="modalImage" class="img-fluid" src="" alt="">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">  
    <!-- Team Section -->
    <div class="row mb-5" id="equipo">
        <div class="col-12 text-center mb-5 animate__animated animate__fadeInUp">
            <h2>Equipo</h2>
        </div>
    </div>  
    <div class="row mb-5" id="equipo">
        <!-- Team Member 1 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/psuquilanda.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Paola Suquilanda</h5>
                    <p class="card-text">Bachelor of Basic Education (Educational Unit Saint Mariana de Jesús)</p>
                </div>
            </div>
        </div>

        <!-- Team Member 2 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Liliana Matute</h5>
                    <p class="card-text">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>

        <!-- Team Member 3 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/kpanama.png'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Karina Panamá Manzheda</h3>
                    <p class="mb-1">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>

        <!-- Team Member 4 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/vrobles.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Vladimir Robles Bykbaev</h5>
                    <p class="mb-1">Doctor PH.D</p>
                    <p class="small">Doctor en Tecnologías de la información y las comunicaciones.</p>
                </div>
            </div>
        </div>

        <!-- Team Member 5 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/elema.png'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Efrén Lema Condo</h5>
                    <p class="card-text">Ingeniero Electrónico</p>
                </div>
            </div>
        </div>

        <!-- Team Member 6 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h5 class="card-title">Carlos Contreras</h5>
                    <p class="card-text">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>
    </div>
</section>